import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';

const styles = theme => ({
    root: {
        margin: 4,
        paddingTop: 64,
        [theme.breakpoints.up('sm')]: {
            width: window.innerWidth >= 768 && window.innerWidth <= 1024 ? 275 : 320,
            position: 'fixed',
            right: 4,
            top: 20,
            margin: 0,
            zIndex: 1101,
            paddingTop: 0,
        }
    },
    card: {
        display: 'flex',
        justifyContent: 'center'
    },
    cardMobile: {
        display: 'flex',
        justifyContent: 'center',
        width: window.innerWidth > 768 ? '' : window.innerWidth <= 320 ? '156%' : window.innerWidth <= 400 ? '130%' :'115%',
        margin: '1%',
    },
    details: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
        padding: '12px !important',
    },
    cover: {
        width: '50%',
        height: 'auto',
        backgroundSize: 'contain'
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    cardContentRoot: {
        padding: 12,
    },
    retailerName: {
        alignSelf: 'center',
        flex: 1,
        padding: 4,
        textAlign: 'center',
        fontFamily: "'Averia Serif Libre', cursive",
        color:'#fa451c',
        //backgroundImage: 'linear-gradient(90deg, #fa451c 0%, #fa451c 15%, #fa451c 30%, #fa451c 44%, #fa451c 58%, #fa451c 72%, #fa451c 86%, #fa451c 100%)',
        backgroundSize: 'cover',
        '-webkit-background-clip': 'text',
        //textFillColor: 'transparent',
    }
});

class RetailerInfo extends Component {

    logout= () =>{
        let redirectUrl = process.env.REACT_APP_WEB_USREDIRECT_URL;
        if(this.props.customer.currencyCode === 'CAD')
        {
            redirectUrl = process.env.REACT_APP_WEB_CADREDIRECT_URL;
        }
        localStorage.removeItem('token');
        localStorage.removeItem('code');
        window.location.href = redirectUrl;
      }

    render() {
        const { classes, customer } = this.props;
        let pagename = this.props.location.pathname.split('/')[1];
        return (
            <div className={classes.root} style={window.innerWidth > 768 ? {} : {paddingTop: '0px'}}>
                {customer && pagename !== 'invoice-info' && pagename !== 'creditmemo-info' && <Card className={window.innerWidth > 768 ? classes.card : classes.cardMobile}>                           
                    <Typography variant="subheading" component="h3" className={classes.retailerName}>
                       <span style={{color:"#fa451c"}}>{customer.code}</span><br/>{customer.name}
                    </Typography>
                    <div className={classes.details}>
                        <CardContent className={classes.content}>
                            <Typography variant="caption" color="textSecondary">
                                {customer.address1}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                                {customer.address2}, {customer.city}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                                {customer.state}, {customer.zipcode}, {customer.country}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                            <div className="search-icon logout" style={{cursor:'pointer',fontSize: '14px',fontWeight: '500',textAlign:'right',margin:'10px 0 0 0',color:'red'}} onClick={this.logout}> <span> Logout </span> <i className="fa fa-sign-out" aria-hidden="true"></i> </div>
                            </Typography>
                        </CardContent>
                    </div>
                </Card>}
            </div>
        );
    }
}

RetailerInfo.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    customer: state.auth.customer,
})

export default connect(mapStateToProps)(withStyles(styles)(withRouter(RetailerInfo)));


// WEBPACK FOOTER //
// ./src/RetailerInfo.js